// extracted by mini-css-extract-plugin
export default {"navigation":"Ty3Yh","navigationList":"_7VkhT","link":"YkRhe","whiteLink":"Sx9su","isActive":"eUm2L","isActiveWhite":"pugQ4"};